import React from 'react'
import styled from '@emotion/styled'
import Facebook from '~/icons/Facebook'
import Twitter from '~/icons/Twitter'
import Instagram from '~/icons/Instagram'
import TikTok from '~/icons/TikTok'

const SocialIcons = props => {
  return (
    <Wrapper className="list--inline site-footer__social-icons social-icons site-footer__icon-list">
      <li>
        <a
          href="https://www.facebook.com/pages/category/Health-Food-Store/getnooro"
          target="_blank"
          rel="noreferrer"
          aria-describedby="a11y-external-message"
        >
          <Facebook />
          <span className="icon__fallback-text">Facebook</span>
        </a>
      </li>
      <li>
        <a
          href="https://twitter.com/getnooro"
          target="_blank"
          rel="noreferrer"
          aria-describedby="a11y-external-message"
        >
          <Twitter />
          <span className="icon__fallback-text">Twitter</span>
        </a>
      </li>
      <li>
        <a
          href="https://www.instagram.com/getnooro/?hl=en"
          target="_blank"
          rel="noreferrer"
          aria-describedby="a11y-external-message"
        >
          <Instagram />
          <span className="icon__fallback-text">Instagram</span>
        </a>
      </li>
      <li>
        <a
          href="https://tiktok.com/@getnooro"
          target="_blank"
          rel="noreferrer"
          aria-describedby="a11y-external-message"
        >
          <TikTok />
          <span className="icon__fallback-text">TikTok</span>
        </a>
      </li>
    </Wrapper>
  )
}

export default SocialIcons

const Wrapper = styled.ul`
  display: flex;
  padding: 0;
  list-style: none;
  margin-bottom: 20px;

  .icon__fallback-text {
    position: absolute !important;
    overflow: hidden;
    clip: rect(0 0 0 0);
    height: 1px;
    width: 1px;
    margin: -1px;
    padding: 0;
    border: 0;
  }

  li {
    margin-right: 20px;

    &:last-child {
      margin-right: 0;
    }

    a {
      color: currentColor;

      &:hover {
        opacity: 0.8;
      }
    }
  }

  svg {
    fill: currentColor;
  }
`
